import Ship from './element/ship/ship';
import Order, { OrderType } from './order/order';


export interface BehaviourParams {
  element: Ship;
}

export default class Behaviour {
  orders: Array<OrderType>;
  element: Ship;

  constructor(params: BehaviourParams) {
    this.element = params.element;
    this.element.behaviour = this;
    this.orders = [];
  }

  canGiveOrder(order: Order): boolean {
    return order.isPossible() && !order.getElement().isManuallyControlled();
  }

  /* Set given order as only order */
  setOrder(order: Order): Array<OrderType> {
    order.behaviour = this;
    if (this.canGiveOrder(order)) {
      this.orders = [order];
      order.onStart();
    }
    return this.orders;
  }

  /*  Add current order as last order in the stack */
  queueOrder(order: OrderType): Array<OrderType> {
    order.behaviour = this;
    if (this.canGiveOrder(order))
      this.orders.push(order);
    return this.orders;
  }

  /*  Add current order as first order in the stack */
  unshiftOrder(order: OrderType): Array<OrderType> {
    order.behaviour = this;
    if (this.canGiveOrder(order)) {
      this.orders.unshift(order);
      order.onStart();
    }
    return this.orders;
  }

  clearOrders(): Array<OrderType> {
    this.orders = [];
    return this.orders;
  }

  getCurrentOrder(): OrderType | undefined {
    return this.orders[0];
  }

  update(modifier: number): Behaviour {
    const currentOrder = this.getCurrentOrder();
    if (!currentOrder)
      return this;
    currentOrder.update(modifier);
    if (currentOrder.isComplete(modifier)) {
      currentOrder.onComplete(modifier);
      this.orders.shift();
      this.getCurrentOrder()?.onStart();
    }
    return this;
  }

  draw(): void {
    this.orders
      .forEach((order, index) => {
        order.draw(index);
      })
      ;
  }
}
